import Manager from "../schemas/Manager";
import { nanoid } from "nanoid";
import { manager } from "./stringConstants";
import { alonTrades } from "./trades/alonTrades";
import { arielTrades } from "./trades/arielTrades";
import { asaTrades } from "./trades/asaTrades";
import { chaunceyTrades } from "./trades/chaunceyTrades";
import { domTrades } from "./trades/domTrades";
import { idanTrades } from "./trades/idanTrades";
import { ilyaTrades } from "./trades/ilyaTrades";
import { itayTrades } from "./trades/itayTrades";
import { jDogTrades } from "./trades/jDogTrades";
import { kobeTrades } from "./trades/kobeTrades";
import { matiTrades } from "./trades/matiTrades";
import { michaelTrades } from "./trades/michaelTrades";
import { nissimTrades } from "./trades/nissimTrades";
import { odedTrades } from "./trades/odedTrades";
import { ranTrades } from "./trades/ranTrades";
import { sagiTrades } from "./trades/sagiTrades";
import { shiranTrades } from "./trades/shiranTrades";
import { yevgenyTrades } from "./trades/yevgenyTrades";
import { zeevTrades } from "./trades/zeevTrades";
import { drorTrades } from "./trades/drorTrades";
import { ronyTrades } from "./trades/ronyTrades";
import { yoniTrades } from "./trades/yoniTrades";
import { shaharTrades } from "./trades/shaharTrades";
import { benTrades } from "./trades/benTrades";

export const managers: Manager[] = [
  {
    id: nanoid(),
    name: manager.yevgeny,
    totalSeasons: 15,
    seasonJoined: "2009/10",
    isActive: true,
    rankings: [1, 2, 3, 2, 1, 6, 6, 5, 3, 7, 3, 2, 8, 2, 7, 5],
    movesPerSeason: [
      337, 518, 471, 631, 380, 200, 200, 200, 200, 200, 169, 200, 200, 200, 200, 200
    ],
    trades: yevgenyTrades,
    draftPositions: [11, 11, 9, 9, 10, 11, 6, 6, 7, 2, 5, 9, 10, 4, 9, 5],
    vetDraftPos: [8, 5, 8, 3, 7, 8, 4, 8, 3],
    bestSnakePicks: [
      {
        pickNumber: 9,
        season: "2012/13",
        draftedPlayer: "Damian Lillard",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 10,
        season: "2013/14",
        draftedPlayer: "Paul Millsap",
        becameKeeper: true,
      },
      {
        pickNumber: 17,
        season: "2016/17",
        draftedPlayer: "Bradley Beal",
      },
      {
        pickNumber: 2,
        season: "2018/19",
        draftedPlayer: "Luka Doncic",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 5,
        season: "2019/20",
        draftedPlayer: "Kyrie Irving",
        becameKeeper: true,
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 9,
        season: "2020/21",
        draftedPlayer: "Kelly Oubre",
      },
      {
        pickNumber: 9,
        season: "2023/24",
        draftedPlayer: "Jordan Poole",
      },
      {
        pickNumber: 18,
        season: "2024/25",
        draftedPlayer: "Jusuf Nurkic",
      },
    ],
    bestVetPicks: [{ player: "Al Horford", position: 5, season: "2017/18" }],
    worstVetPicks: [
      { player: "Rajon Rondo", position: 8, season: "2016/17" },
      { player: "Danilo Gallinari", position: 3, season: "2019/20" },
      { player: "Kemba Walker", position: 8, season: "2021/22" },
    ],
    notableSleepers: [
      {
        name: "Kyrie Irving",
        pickedUpVia: "הגיע כרוקי תמורת דורל רייט ואוגוסטין",
        seasonPicked: "2011/12",
        valueYielded: "הועבר כרוקי עם אמקה אוקאפור לפילוזרס תמורת אנדרו ביינום",
        amongBestSleepers: true,
      },
      {
        name: "Isaiah Thomas",
        pickedUpVia: "הורם כפרי אייג'נט סופמור",
        seasonPicked: "2012/13",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2014/15",
        amongBestSleepers: true,
      },
      {
        name: "Damian Lillard",
        pickedUpVia: "נבחר תשיעי בדראפט כרוקי",
        seasonPicked: "2012/13",
        madeFourthYear: true,
        becameFreeKeeper: true,
        valueYielded: "הועבר בעונת 2015/16 לצד איבקה תמורת קוואי לאונרד",
        amongBestSleepers: true
      },
      {
        name: "Nikola Vucevic",
        pickedUpVia: "הובא כסופמור תמורת קווין מרטין",
        seasonPicked: "2012/13",
        madeFourthYear: true,
        becameFreeKeeper: true,
        valueYielded:
          "נשלח בעונת 2014/15 עם אייזיאה תומאס תמורת וויגינס הרוקי ומרקיף מוריס",
          amongBestSleepers: true
      },
      {
        name: "Andrew Wiggins",
        pickedUpVia: "צורף כרוקי לצד מרקיף מוריס תמורת ווצ'ביץ' ואייזיאה תומאס",
        seasonPicked: "2014/15",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2017/18",
        amongWorstSleepers: true
      },
      {
        name: "Devin Booker",
        pickedUpVia: "הגיע כסופמור לצד גובר וקליי תמורת קוואי, רנדל ואחרים",
        seasonPicked: "2016/17",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "שחקן פרנצ'ייז נכון לעונת 2024/25 והלאה",
        amongBestSleepers: true
      },
      {
        name: "Kristaps Porzingis",
        pickedUpVia: "צורף כסופמור לצד גלינארי תמורת גובר וקליי",
        seasonPicked: "2016/17",
        valueYielded:
          "הועבר בעונתו השלישית תמורת מידלטון",
          amongBestSleepers: true
      },
      {
        name: "Jahlil Okafor",
        pickedUpVia: "נבחר שישי כרוקי",
        seasonPicked: "2015/16",
        valueYielded: "הועבר כסופמור לצד ביל תמורת מרק גאסול",
        amongBestSleepers: true
      },
      {
        name: "Lauri Markkanen",
        pickedUpVia: "בחירת סיבוב אחרון כרוקי",
        seasonPicked: "2017/18",
        valueYielded: "הועבר כרוקי עם שרודר תמורת מילסאפ והוד",
        amongBestSleepers: true
       },
       {
        name: "Jarrett Allen",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2017/18",
        valueYielded: "הועבר כסופמור לצד גיי תמורת קאפלה",
        amongBestSleepers: true
       },
       {
        name: "De'Aaron Fox",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2017/18",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2019/20",
        valueYielded: "הועבר עם פורזינגיס תמורת קאפלה, שהפך לקיפר חופשי",
        amongBestSleepers: true
       },
       {
        name: "Deandre Ayton",
        pickedUpVia: "צורף כרוקי לצד מילסאפ ושאריץ' תמורת לוקה וטריי",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2023/24",
        amongBestSleepers: true
       },
       {
        name: "Luka Doncic",
        pickedUpVia: "נבחר שני כרוקי",
        seasonPicked: "2018/19",
        valueYielded: "הועבר לצד טריי תמורת אייטון ואחרים"
       },
       {
        name: "Trae Young",
        pickedUpVia: "הובא כרוקי לצד לאב והאריסון בארנס תמורת מידלטון, טוביאס ורדיק",
        seasonPicked: "2018/19",
        valueYielded: "הועבר כרוקי לצד לוקה תמורת אייטון ואחרים",
        amongBestSleepers: true
       },
       {
        name: "Shai Gilgeous-Alexander",
        pickedUpVia: "הובא כרוקי תמורת לארי נאנס ג'וניור",
        seasonPicked: "2018/19",
        valueYielded: "בעונתו השלישית, הוחלף במידלטון",
        amongBestSleepers: true
       },
       {
        name: "Kevin Huerter",
        pickedUpVia:  "הרמת ווייבר באמצע עונת הסופמור",
        seasonPicked: "2019/20",
        valueYielded: "נשלח עם שרודר תמורת אדמס",
        amongBestSleepers: true
       },
       {
        name: "LaMelo Ball",
        pickedUpVia: "בחירה סוף סיבוב שלישי כרוקי",
        seasonPicked: "2020/21",
        valueYielded: "הועבר כרוקי לצד אדמס תמורת סיאקם",
        amongBestSleepers: true
       },
       {
        name: "Cole Anthony",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2020/21",
        valueYielded: "הועבר כרוקי לצד קיירי תמורת קוואי",
        amongBestSleepers: true
       },
       {
        name: "Alperen Sengun",
        pickedUpVia: "הובא כרוקי תמורת רנדל וטייט",
        seasonPicked: "2021/22",
        madeFourthYear: true,
        amongBestSleepers: true
       },
       {
        name: "Josh Giddey",
        pickedUpVia: "נבחר בשלהי סיבוב שלישי כרוקי",
        seasonPicked: "2021/22",
        madeFourthYear: false,
        valueYielded: "תרם את שלו כסופמור לזכייה בחצי מדליית כסף",
        keptUntil: "שוחרר במהלך עונתו השלישית",
        amongBestSleepers: true
       },
       {
        name: "Amen Thompson",
        pickedUpVia: "הורם באמצע עונת הרוקי",
        seasonPicked: "2023/24",
        amongBestSleepers: true
       },
    ],
  },
  {
    id: nanoid(),
    name: manager.dom,
    totalSeasons: 15,
    seasonJoined: "2009/10",
    isActive: true,
    rankings: [2, 8, 9, 9, 8, 2, 3, 10, 11, 8, 5, 3, 6, 6, 8, 6],
    movesPerSeason: [
      163, 173, 122, 135, 136, 148, 200, 117, 39, 99, 90, 111, 109, 98, 109, 118
    ],
    trades: domTrades,
    draftPositions: [8, 10, 4, 2, 3, 4, 10, 9, 2, 1, 4, 7, 9, 6, 5, 4],
    vetDraftPos: [7, 10, 11, 4, 1, 7, 2, 3, 4],
    bestSnakePicks: [
      {
        pickNumber: 3,
        season: "2013/14",
        draftedPlayer: "Eric Bledsoe",
        becameKeeper: true,
      },
      {
        pickNumber: 20,
        season: "2013/14",
        draftedPlayer: "Goran Dragic",
      },
      {
        pickNumber: 4,
        season: "2014/15",
        draftedPlayer: "Gordon Hayward",
        becameKeeper: true,
      },
      {
        pickNumber: 21,
        season: "2017/18",
        draftedPlayer: "Jayson Tatum",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 4,
        season: "2019/20",
        draftedPlayer: "Jimmy Butler",
        becameKeeper: true,
      },
      {
        pickNumber: 19,
        season: "2019/20",
        draftedPlayer: "Jonas Valanciunas",
        becameKeeper: true,
      },
      {
        pickNumber: 6,
        season: "2022/23",
        draftedPlayer: "Myles Turner",
        becameKeeper: true,
      },
      {
        pickNumber: 17,
        season: "2022/23",
        draftedPlayer: "Jaren Jackson Jr",
        becameKeeper: true,
      },
      {
        pickNumber: 4,
        season: "2024/25",
        draftedPlayer: "Jarrett Allen",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 16,
        season: "2020/21",
        draftedPlayer: "DeMarcus Cousins",
      },
      {
        pickNumber: 9,
        season: "2021/22",
        draftedPlayer: "Richaun Holmes",
      },
    ],
    bestVetPicks: [
      { player: "Paul Millsap", position: 11, season: "2018/19" },
      { player: "DeMar DeRozan", position: 4, season: "2019/20" },
      { player: "James Harden", position: 3, season: "2023/24" },
      { player: "Damian Lillard", position: 4, season: "2024/25" },
    ],
    worstVetPicks: [],
    notableSleepers: [
      {
        name: "Danilo Gallinari",
        pickedUpVia: "בחירה 45 בדראפט הג'נסיס",
        seasonPicked: "2009/10",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2011/12",
        amongBestSleepers: true,
      },
      {
        name: "Jonas Valanciunas",
        pickedUpVia: "הגיע כסופמור עם רג'י ג'קסון תמורת דראגיץ' ופאריד",
        seasonPicked: "2013/14",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2015/16",
        amongBestSleepers: true,
      },
      {
        name: "Nikola Pekovic",
        pickedUpVia: "הורם כסופמור בסטרץ' הפריצה",
        seasonPicked: "2011/12",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2013/14",
        valueYielded: "נשלח עם לאוסון והוז תמורת איבקה ובוזר",
        amongBestSleepers: true,
      },
      {
        name: "Kenneth Faried",
        pickedUpVia: "הורם כרוקי בסטרץ' הפריצה",
        seasonPicked: "2011/12",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2013/14",
        valueYielded: "נשלח עם דראגיץ' תמורת ולנצ'יונאס ורג'י ג'קסון",
        amongBestSleepers: true,
      },
      {
        name: "Michael Carter-Williams",
        pickedUpVia: "נרכש כרוקי לצד ג'אמיר נלסון תמורת איבקה וג'נינגס",
        seasonPicked: "2013/14",
        madeFourthYear: false,
        becameFreeKeeper: false,
        valueYielded:
          "הועבר כסופמור תמורת דראגיץ' וברנדון נייט",
          amongBestSleepers: true
      },
      {
        name: "Aaron Gordon",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הסופמור",
        seasonPicked: "2015/16",
        valueYielded:
          "הועבר כסופמור תמורת אלדריג' וביל",
          amongBestSleepers: true
      },
      {
        name: "Lonzo Ball",
        pickedUpVia: "נבחר שני כרוקי",
        seasonPicked: "2017/18",
        valueYielded: "הועבר לצד דרוזן תמורת ג'ון קולינס כשחקן פרנ'צייז",
        amongBestSleepers: true
       },
       {
        name: "Jayson Tatum",
        pickedUpVia: "בחירה 21 כרוקי",
        seasonPicked: "2017/18",
        valueYielded: "הועבר כרוקי תמורת ארון גורדון",
        amongBestSleepers: true
       },
       {
        name: "Lauri Markkanen",
        pickedUpVia: "צורף כרוקי עם שרודר תמורת מילסאפ והוד",
        seasonPicked: "2017/18",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2020/21",
        amongBestSleepers: true
       },
       {
        name: "Deandre Ayton",
        pickedUpVia: "נבחר ראשון כרוקי",
        seasonPicked: "2018/19",
        valueYielded: "הועבר כיעד העיקרי תמורת לוקה וטריי",
        amongBestSleepers: true
       },
       {
        name: "Luka Doncic",
        pickedUpVia: "הגיע כרוקי לצד טריי תמורת אייטון ואחרים",
        seasonPicked: "2018/19",
        valueYielded: "הועבר בעונתו השלישית תמורת הארדן",
        amongBestSleepers: true
       },
       {
        name: "Trae Young",
        pickedUpVia: "הגיע כרוקי לצד לוקה תמורת אייטון ואחרים",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        keptUntil: "שחקן פרנצ'ייז עד לימים אלו והלאה",
        amongBestSleepers: true
       },
       {
        name: "Desmond Bane",
        pickedUpVia: "הרמת סוף עונה כפרי אייג'נט רוקי",
        seasonPicked: "2020/21",
        madeFourthYear: true,
        becameFreeKeeper: true,
        amongBestSleepers: true
       },
       {
        name: "Brandon Miller",
        pickedUpVia: "בחירת אמצע סיבוב שני כרוקי",
        seasonPicked: "2023/24",
        valueYielded: "דונובן מיטשל וגריידי דיק",
        amongBestSleepers: true
       },
    ],
  },
  {
    id: nanoid(),
    name: manager.nissim,
    totalSeasons: 15,
    seasonJoined: "2009/10",
    isActive: true,
    rankings: [3, 3, 5, 7, 3, 5, 5, 4, 3, 4, 1, 7, 1, 1, 3, 6],
    movesPerSeason: [
      158, 184, 155, 137, 151, 159, 115, 170, 196, 106, 97, 109, 156, 156, 151, 159
    ],
    trades: nissimTrades,
    draftPositions: [6, 9, 8, 6, 5, 9, 7, 7, 8, 8, 8, 11, 5, 11, 11, 9],
    vetDraftPos: [5, 8, 7, 6, 9, 3, 9, 9, 7],
    bestSnakePicks: [
      {
        pickNumber: 15,
        draftedPlayer: "Marcin Gortat",
        season: "2011/12",
        becameKeeper: true,
      },
      {
        pickNumber: 7,
        season: "2015/16",
        draftedPlayer: "Hassan Whiteside",
        becameKeeper: true,
      },
      {
        pickNumber: 15,
        season: "2017/18",
        draftedPlayer: "Otto Porter Jr",
      },
      {
        pickNumber: 5,
        season: "2021/22",
        draftedPlayer: "Evan Mobley",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 18,
        season: "2021/22",
        draftedPlayer: "Robert Williams",
      },
      {
        pickNumber: 11,
        season: "2022/23",
        draftedPlayer: "Clint Capela",
      },
      {
        pickNumber: 14,
        season: "2024/25",
        draftedPlayer: "Michael Porter Jr",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 14,
        season: "2014/15",
        draftedPlayer: "Larry Sanders",
      },
      {
        pickNumber: 11,
        season: "2020/21",
        draftedPlayer: "Davis Bertans",
      },
      {
        pickNumber: 12,
        season: "2020/21",
        draftedPlayer: "Montrezl Harrell",
      },
    ],
    bestVetPicks: [
      { player: "Rudy Gay", position: 5, season: "2016/17" },
      { player: "Kyle Lowry", position: 6, season: "2019/20" },
      { player: "Chris Paul", position: 3, season: "2021/22" },
      { player: "Nikola Vucevic", position: 7, season: "2024/25" },
    ],
    worstVetPicks: [
      { player: "Marcin Gortat", position: 8, season: "2017/18" },
      { player: "Goran Dragic", position: 7, season: "2018/19" },
      { player: "John Wall", position: 9, season: "2020/21" },
      { player: "Khris Middleton", position: 9, season: "2022/23" },
    ],
    notableSleepers: [
      {
        name: "James Harden",
        pickedUpVia: "הורם מהווייברס כסופמור",
        seasonPicked: "2010/11",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2020/21",
        valueYielded: "הוחלף כקיפר חופשי ותיק בלוקה הצעיר",
        amongBestSleepers: true,
      },
      {
        name: "Jonas Valanciunas",
        pickedUpVia: "הורם ביום האחרון לעונה טרם הגעתו מאירופה",
        seasonPicked: "2011/12",
        valueYielded: "הועבר כסופמור עם רג'י ג'קסון תמורת דראגיץ' ופאריד",
        amongBestSleepers: true,
      },
      {
        name: "Aaron Gordon",
        pickedUpVia: "צורף כסופמור תמורת אלדריג' וביל",
        seasonPicked: "2015/16",
        madeFourthYear: true,
        valueYielded:
          "הועבר בעונתו הרביעית תמורת טייטום הרוקי",
          amongBestSleepers: true
      },
      {
        name: "Pascal Siakam",
        pickedUpVia: "הורם ביום האחרון לעונת הסופמור שלו",
        seasonPicked: "2017/18",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2020/21, לאחר תרומתו לאליפות ראשונה לפרנצ'ייז",
        valueYielded: "הועבר תמורת לאמלו",
        amongBestSleepers: true
       },
       {
        name: "Jayson Tatum",
        pickedUpVia: "צורף כרוקי תמורת ארון גורדון",
        seasonPicked: "2017/18",
        madeFourthYear: true,
        becameFreeKeeper: true,
        amongBestSleepers: true
       },
       {
        name: "Jaren Jackson Jr",
        pickedUpVia: "נבחר בסיבוב השלישי כרוקי",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2020/21",
        valueYielded: "סיים קדנציה של ארבע שנים במצב בלתי סחיר בשל פציעה שנגררה לפתיחת עונתו החמישית",
        amongBestSleepers: true
       },
       {
        name: "LaMelo Ball",
        pickedUpVia: "הגיע כרוקי לצד אדמס תמורת סיאקם",
        seasonPicked: "2020/21",
        madeFourthYear: true,
        valueYielded: "הועבר כשחקן השבחה תמורת הולמגרן",
        amongBestSleepers: true
       },
       {
        name: "Evan Mobley",
        pickedUpVia: "נבחר חמישי כרוקי",
        seasonPicked: "2021/22",
        madeFourthYear: true,
        amongBestSleepers: true
       },
       {
        name: "Chet Holmgren",
        pickedUpVia: "צורף בתחילת עונת הרוקי תמורת לאמלו",
        seasonPicked: "2023/24",
        amongBestSleepers: true
       },
    ],
  },
  {
    id: nanoid(),
    name: manager.itay,
    totalSeasons: 15,
    seasonJoined: "2009/10",
    isActive: true,
    rankings: [4, 4, 10, 3, 5, 9, 8, 11, 7, 5, 6, 6, 11, 11, 4, 8],
    movesPerSeason: [
      24, 181, 67, 81, 178, 32, 88, 143, 145, 162, 137, 139, 127, 165, 172, 122
    ],
    trades: itayTrades,
    draftPositions: [3, 8, 7, 1, 9, 7, 3, 2, 1, 5, 7, 6, 6, 1, 1, 8],
    vetDraftPos: [2, 11, 2, 1, 2, 2, 11, 11, 6],
    bestSnakePicks: [
      {
        pickNumber: 1,
        season: "2012/13",
        draftedPlayer: "Anthony Davis",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 22,
        season: "2012/13",
        draftedPlayer: "Joakim Noah",
      },
      {
        pickNumber: 5,
        season: "2018/19",
        draftedPlayer: "Trae Young",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 6,
        season: "2020/21",
        draftedPlayer: "Jaylen Brown",
        becameKeeper: true,
      },
      {
        pickNumber: 1,
        season: "2023/24",
        draftedPlayer: "Victor Wembenyama",
        becameKeeper: true,
        wasSleeper: true,
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 20,
        season: "2015/16",
        draftedPlayer: "Emmanuel Mudiay",
        becameKeeper: false,
        wasSleeper: true,
      },
      {
        pickNumber: 1,
        season: "2017/18",
        draftedPlayer: "Markelle Fultz",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 22,
        season: "2022/23",
        draftedPlayer: "Collin Sexton",
      },
    ],
    bestVetPicks: [
      { player: "Chris Paul", position: 2, season: "2020/21" },
      { player: "Klay Thompson", position: 11, season: "2022/23" },
      { player: "CJ McCollum", position: 11, season: "2023/24" },
      { player: "LeBron James", position: 6, season: "2024/25" },
    ],
    worstVetPicks: [{ player: "Dwyane Wade", position: 11, season: "2017/18" }],
    notableSleepers: [
      {
        name: "Kyrie Irving",
        pickedUpVia: "הגיע כרוקי עם אמקה אוקאפור תמורת אנדרו ביינום",
        seasonPicked: "2011/12",
        valueYielded:
          "הועבר כסופמור עם פטריק פטרסון תמורת סטף קארי וכרמלו אנתוני",
        amongBestSleepers: true,
      },
      {
        name: "Anthony Davis",
        pickedUpVia: "בחירה ראשונה בדראפט כרוקי",
        seasonPicked: "2012/13",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2018/19",
        valueYielded: "הועבר כקיפר חופשי תמורת חבילה שכללה את אמביד כשחקן פרנצ'ייז, טרנר כקיפר חופשי וג'ארט אלן כסליפר",
        amongBestSleepers: true
      },
      {
        name: "Michael Carter-Williams",
        pickedUpVia: "בחירת שלהי סיבוב אחרון כרוקי",
        seasonPicked: "2013/14",
        valueYielded:
          "הועבר כרוקי לצד ג'אמיר נלסון תמורת איבקה וג'נינגס ",
          amongBestSleepers: true
      },
      {
        name: "Nerlens Noel",
        pickedUpVia: "הורם כרוקי פצוע חודש לפני סיום העונה",
        seasonPicked: "2013/14",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "איבד מערכו המועט כשחקן פרנצ'ייז לאחר שקובינגטון הוחזר בטרייד",
        amongBestSleepers: true
      },
      {
        name: "Ben Simmons",
        pickedUpVia: "נבחר רביעי כרוקי (היה אמור להיבחר שני במקום לאב)",
        seasonPicked: "2016/17",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2021/22",
        amongBestSleepers: true
      },
      {
        name: "Markelle Fultz",
        pickedUpVia: "נבחר ראשון כרוקי",
        seasonPicked: "2017/18",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2018/19",
        amongWorstSleepers: true
       },
       {
        name: "Jarrett Allen",
        pickedUpVia: "הגיע כסופמור כחלק מהחבילה עבור אנתוני דייויס",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2019/20",
        amongBestSleepers: true
       },
       {
        name: "Trae Young",
        pickedUpVia: "נבחר חמישי כרוקי",
        seasonPicked: "2018/19",
        valueYielded: "הועבר כרוקי לצד לאב והאריסון בארנס תמורת מידלטון, טוביאס ורדיק",
        amongBestSleepers: true
       },
       {
        name: "Tyler Herro",
        pickedUpVia: "הרמת סוף עונת סופמור מהווייברס",
        seasonPicked: "2020/21",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2022/23",
        amongBestSleepers: true
       },
       {
        name: "Paolo Banchero",
        pickedUpVia: "נבחר ראשון כרוקי",
        seasonPicked: "2022/23",
        amongBestSleepers: true
       },
       {
        name: "Victor Wembenyama",
        pickedUpVia: "נבחר ראשון כרוקי",
        seasonPicked: "2023/24",
        amongBestSleepers: true
       },
    ],
  },
  {
    id: nanoid(),
    name: manager.mati,
    totalSeasons: 15,
    seasonJoined: "2009/10",
    isActive: true,
    rankings: [9, 12, 1, 6, 7, 11, 7, 2, 9, 11, 4, 5, 4, 2, 6, 1],
    movesPerSeason: [
      52, 35, 161, 63, 24, 36, 104, 200, 200, 200, 133, 199, 200, 200, 176, 189
    ],
    trades: matiTrades,
    draftPositions: [5, 3, 2, 11, 6, 5, 1, 5, 13, 3, 1, 8, 7, 8, 13, 2],
    vetDraftPos: [3, 6, 1, 11, 6, 1, 6, 7, 2],
    bestSnakePicks: [
      {
        pickNumber: 5,
        draftedPlayer: "Kevin Durant",
        season: "2009/10",
        becameKeeper: true,
      },
      {
        pickNumber: 22,
        draftedPlayer: "Blake Griffin",
        season: "2009/10",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 21,
        season: "2011/12",
        draftedPlayer: "Tim Duncan",
      },
      {
        pickNumber: 5,
        season: "2014/15",
        draftedPlayer: "DeAndre Jordan",
        becameKeeper: true,
      },
      {
        pickNumber: 13,
        season: "2017/18",
        draftedPlayer: "Victor Oladipo",
        becameKeeper: true,
      },
      {
        pickNumber: 3,
        season: "2018/19",
        draftedPlayer: "Clint Capela",
        becameKeeper: true,
      },
      {
        pickNumber: 22,
        season: "2019/20",
        draftedPlayer: "Fred VanVleet",
        becameKeeper: true,
      },
      {
        pickNumber: 16,
        season: "2021/22",
        draftedPlayer: "Jarrett Allen",
        becameKeeper: true,
      },
      {
        pickNumber: 2,
        season: "2024/25",
        draftedPlayer: "Jalen Johnson",
        becameKeeper: true,
      },
      {
        pickNumber: 17,
        season: "2024/25",
        draftedPlayer: "Derrick White"
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 3,
        draftedPlayer: "Troy Murphy",
        season: "2010/11",
      },
      {
        pickNumber: 8,
        season: "2020/21",
        draftedPlayer: "Robert Covington",
      },
    ],
    bestVetPicks: [
      { player: "Dwight Howard", position: 3, season: "2016/17" },
      { player: "Lou Williams", position: 6, season: "2017/18" },
      { player: "Nikola Vucevic", position: 6, season: "2022/23" },
      { player: "Rudy Gobert", position: 7, season: "2023/24" },
      { player: "Kevin Durant", position: 2, season: "2024/25" },
    ],
    worstVetPicks: [],
    notableSleepers: [
      {
        name: "Blake Griffin",
        pickedUpVia: "בחירה 22 בדראפט הג'נסיס",
        seasonPicked: "2009/10",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2013/14",
        valueYielded: "הועבר תמורת מרק גאסול ופארסונס",
        amongBestSleepers: true,
      },
      {
        name: "Jabari Parker",
        pickedUpVia: "צורף כרוקי בעסקה מרובת שחקנים שהבולט בה היה ג'ורדן",
        seasonPicked: "2014/15",
        valueYielded:
          "הועבר לקראת עונתו השלישית תמורת בחירה בתחילת הסיבוב השלישי",
          amongBestSleepers: true
      },
      {
        name: "Zach LaVine",
        pickedUpVia: "הורם כפרי אייג'נט סופמור",
        seasonPicked: "2015/16",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "אמצע עונת 2016/17, נזרק בשל פציעה",
        amongBestSleepers: true
      },
      {
        name: "Myles Turner",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2015/16",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2018/19",
        valueYielded: "הועבר יחד עם יאניס, ג'ארט אלן ופול תמורת החדגבה ותוספות",
        amongBestSleepers: true
      },
      {
        name: "D'Angelo Russell",
        pickedUpVia: "הורם כפרי אייג'נט בתחילת עונת הרוקי",
        seasonPicked: "2015/16",
        valueYielded: "הועבר כסופמור תמורת לין",
        amongBestSleepers: true
      },
      {
        name: "Jarrett Allen",
        pickedUpVia: "צורף כסופמור לצד גיי תמורת קאפלה",
        seasonPicked: "2018/19",
        valueYielded: "הועבר כסופמור כחלק מהחבילה תמורת אנתוני דייויס",
        amongBestSleepers: true
       },
       {
        name: "Domantas Sabonis",
        pickedUpVia: "הורם בתחילת עונת הסופמור",
        seasonPicked: "2017/18",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2023/24",
        valueYielded: "הועבר עם איסון תמורת ג'יי-דאב הסופמור ופולטל",
        amongBestSleepers: true
       },
       {
        name: "Bam Adebayo",
        pickedUpVia: "הרמת ווייברס באמצע עונת הסופמור",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "שלהי עונת 2020/21 כשחקן השבחה",
        valueYielded: "הועבר תמורת האליברטון בעונת הרוקי שלו",
        amongBestSleepers: true
       },
       {
        name: "Zion Williamson",
        pickedUpVia: "בחירה ראשונה",
        seasonPicked: "2019/20",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "הגעת מים פצועים עד נפש...שוחרר בעונתו השלישית, 2021/22",
        amongWorstSleepers: true
       },
       {
        name: "Devonte Graham",
        pickedUpVia: "הגיע לקראת עונתו השלישית בתמורה להחלפת בחירת סיבוב שלישי בבחירת סיבוב רביעי",
        seasonPicked: "2020/21",
        madeFourthYear: false,
        becameFreeKeeper: false,
        amongWorstSleepers: true
       },
       {
        name: "Tyrese Haliburton",
        pickedUpVia: "הגיע כרוקי תמורת באם",
        seasonPicked: "2020/21",
        madeFourthYear: true,
        keptUntil: "שחקן פרנצ'ייז לעתיד הנראה לעין ומעבר לו",
        amongBestSleepers: true
       },
       {
        name: "Davin Vassell",
        pickedUpVia: "הורם כפרי אייג'נט בשלהי עונת הסופמור",
        seasonPicked: "2021/22",
        madeFourthYear: true,
        becameFreeKeeper: false,
        valueYielded: "הועבר לקראת עונה שלישית בתמורה לבחירת סיבוב שלישי",
        amongBestSleepers: true
       },
       {
        name: "Franz Wagner",
        pickedUpVia: "הורם כפרי אייג'נט בתחילת עונת הרוקי",
        seasonPicked: "2021/22",
        valueYielded: "תרם לזכייה בחצי מדליית כסף והועבר לקראת עונה שלישית תמורת מיקאל ברידג'ס",
        amongBestSleepers: true
       },
       {
        name: "Keegan Murray",
        pickedUpVia: "נבחר בתחילת סיבוב שלישי כרוקי",
        seasonPicked: "2022/23",
        valueYielded: "הועבר כרוקי לצד ג'מארי, MPJ ובחירת סיבוב ראשון תמורת לברון, בחירת סיבוב שלישי וגובר",
        amongBestSleepers: true
       },
       {
        name: "Jalen Williams",
        pickedUpVia: "צורף כסופמור עם פולטל תמורת סבוניס ג'וניור ואיסון",
        seasonPicked: "2022/24",
        amongBestSleepers: true,
        madeFourthYear: true
       },
       {
        name: "Trey Murphy",
        pickedUpVia: "הורם כפרי אייג'נט בשלהי עונת הסופמור",
        seasonPicked: "2022/23",
        valueYielded: "הועבר לקראת עונה שלישית תמורת מרקנן (שהומר מידית לטרנר כשחקן פרנצ'ייז)",
        amongBestSleepers: false
       },
      
    ],
  },
  {
    id: nanoid(),
    name: manager.kobe,
    totalSeasons: 15,
    seasonJoined: "2009/10",
    isActive: true,
    rankings: [8, 13, 7, 10, 6, 4, 9, 6, 3, 10, 7, 11, 7, 7, 9, 8],
    movesPerSeason: [
      130, 30, 87, 30, 122, 200, 200, 183, 200, 165, 113, 93, 200, 200, 15, 125
    ],
    trades: kobeTrades,
    draftPositions: [1, 4, 1, 4, 2, 6, 8, 1, 6, 9, 2, 5, 1, 5, 4, 8],
    vetDraftPos: [1, 3, 5, 10, 3, 11, 3, 4, 5],
    bestSnakePicks: [
      {
        pickNumber: 4,
        draftedPlayer: "Rudy Gay",
        season: "20010/11",
        becameKeeper: true,
      },
      {
        pickNumber: 22,
        season: "2011/12",
        draftedPlayer: "Paul Pierce",
      },
      {
        pickNumber: 4,
        season: "2012/13",
        draftedPlayer: "Marc Gasol",
        becameKeeper: true,
      },
      {
        pickNumber: 6,
        season: "2014/15",
        draftedPlayer: "Rudy Gay",
        becameKeeper: true,
      },
      {
        pickNumber: 9,
        season: "2018/19",
        draftedPlayer: "Blake Griffin",
        becameKeeper: true,
      },
      {
        pickNumber: 2,
        season: "2019/20",
        draftedPlayer: "Ja Morant",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 1,
        season: "2021/22",
        draftedPlayer: "Cade Cunningham",
        becameKeeper: true,
      },
      {
        pickNumber: 18,
        season: "2022/23",
        draftedPlayer: "Lauri Markkanen",
        amongBestPicks: true,
      },
      {
        pickNumber: 4,
        season: "2023/24",
        draftedPlayer: "Jalen Brunson",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 21,
        season: "2019/20",
        draftedPlayer: "Eric Bledsoe",
      },
      {
        pickNumber: 18,
        season: "2020/21",
        draftedPlayer: "Victor Oladipo",
      },
      {
        pickNumber: 3,
        season: "2024/25",
        draftedPlayer: "Zion Williamson",
      },
    ],
    bestVetPicks: [{ player: "DeMar DeRozan", position: 4, season: "2023/24" }],
    worstVetPicks: [
      { player: "Carmelo Anthony", position: 1, season: "2016/17" },
      { player: "Dwight Howard", position: 5, season: "2018/19" },
      { player: "Blake Griffin", position: 3, season: "2020/21" },
    ],
    notableSleepers: [
      {
        name: "Greg Monroe",
        pickedUpVia: "הורם כפרי אייג'נט רוקי",
        seasonPicked: "2010/11",
        madeFourthYear: true,
        keptUntil: "2014/15, עם סיום תפקידו כשחקן פרנצ'ייז",
        amongBestSleepers: true,
      },
      {
        name: "Andre Drummond",
        pickedUpVia: "בחירת סיבוב אחרון בדראפט כרוקי",
        seasonPicked: "2012/13",
        madeFourthYear: true,
        keptUntil: "2020/21 עם סיום תפקידו כשחקן פרנצ'ייז",
        amongBestSleepers: true
      },
      {
        name: "Caris LeVert",
        pickedUpVia: "הורם כפרי אייג'נט בשלהי עונת הסופמור",
        seasonPicked: "2016/17",
        valueYielded: "הוחלף בתחילת עונתו השלישית בברוגדון, שהפך לקיפר חופשי למשך עונה אחת",
        amongBestSleepers: true
       },
       {
        name: "Donovan Mitchell",
        pickedUpVia: "הובא כסופמור תמורת לברון ג'יימס",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2023/24",
        amongBestSleepers: true
       },
       {
        name: "Kyle Kuzma",
        pickedUpVia: "נבחר כרוקי באמצע הסיבוב הרביעי",
        seasonPicked: "2017/18",
        valueYielded: "הועבר כרוקי תמורת מידלטון",
        amongBestSleepers: true
       },
       {
        name: "Ja Morant",
        pickedUpVia: "בחירה שנייה",
        seasonPicked: "2019/20",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2022/23",
        valueYielded: "הועבר לצד האריסון בארנס תמורת דורן ודיאנג'לו ראסל",
        amongBestSleepers: true
       },
       {
        name: "Shai Gilgeous-Alexander",
        pickedUpVia: "הובא תמורת מידלטון בעונתו השלישית",
        seasonPicked: "2020/21",
        becameFreeKeeper: true,
        keptUntil: "עונת הפריצה - 2022/23 - במהלכה הוחלף ביאניס",
        amongBestSleepers: true
       },
       {
        name: "Cade Cunningham",
        pickedUpVia: "נבחר ראשון כרוקי",
        seasonPicked: "2021/22",
        madeFourthYear: true,
        amongBestSleepers: true
       },
    ],
  },
  {
    id: nanoid(),
    name: manager.ariel,
    totalSeasons: 15,
    seasonJoined: "2009/10",
    isActive: true,
    rankings: [12, 1, 2, 5, 4, 3, 1, 6, 7, 9, 9, 4, 3, 8, 5, 2],
    movesPerSeason: [
      22, 295, 289, 348, 376, 199, 200, 189, 171, 198, 88, 194, 190, 156, 199, 199
    ],
    trades: arielTrades,
    draftPositions: [2, 1, 10, 10, 7, 8, 9, 11, 5, 19, 3, 2, 8, 9, 3, 7],
    vetDraftPos: [6, 4, 3, 5, 10, 6, 7, 5, 1],
    bestSnakePicks: [
      {
        pickNumber: 25,
        draftedPlayer: "Kevin Love",
        season: "2009/10",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 9,
        season: "2015/16",
        draftedPlayer: "Danny Green",
      },
      {
        pickNumber: 14,
        season: "2015/16",
        draftedPlayer: "Nicolas Batum",
        becameKeeper: true,
      },
      {
        pickNumber: 11,
        season: "2016/17",
        draftedPlayer: "Joel Embiid",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 20,
        season: "2019/20",
        draftedPlayer: "Terry Rozier",
        becameKeeper: true,
      },
      {
        pickNumber: 2,
        season: "2020/21",
        draftedPlayer: "Jamal Murray",
      },
      {
        pickNumber: 21,
        season: "2020/21",
        draftedPlayer: "Tobias Harris",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 8,
        season: "2014/15",
        draftedPlayer: "Derrick Rose",
      },
      {
        pickNumber: 3,
        season: "2019/20",
        draftedPlayer: "RJ Barrett",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 15,
        season: "2021/22",
        draftedPlayer: "D'Angelo Russell",
      },
      {
        pickNumber: 7,
        season: "2024/25",
        draftedPlayer: "Nick Claxton",
      },
    ],
    bestVetPicks: [
      { player: "Chris Paul", position: 5, season: "2020/21" },
      { player: "DeMar DeRozan", position: 6, season: "2021/22" },
      { player: "LeBron James", position: 5, season: "2023/24" },
      { player: "James Harden", position: 1, season: "2024/25" },
    ],
    worstVetPicks: [
      { player: "Carmelo Anthony", position: 4, season: "2017/18" },
      { player: "Lou Williams", position: 10, season: "2020/21" },
    ],
    notableSleepers: [
      {
        name: "Kevin Love",
        pickedUpVia: "בחירה 25 בדראפט הג'נסיס",
        seasonPicked: "2009/10",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2015/16",
        valueYielded:
          "הוחלף בפייבורס, שהומר עם טאקר בגורטאט וקונלי, שתרמו לחצי מדליית זהב",
        amongBestSleepers: true,
      },
      {
        name: "Serge Ibaka",
        pickedUpVia: "נבחר 27 כסופמור",
        seasonPicked: "2010/11",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "הועבר במהלך עונת 2013/14",
        valueYielded: "הוחלף בקובי בריאנט",
        amongBestSleepers: true,
      },
      {
        name: "Kemba Walker",
        pickedUpVia: "בחירת סיבוב אחרון בדראפט כרוקי",
        seasonPicked: "2011/12",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2014/15",
        amongBestSleepers: true,
      },
      {
        name: "Bradley Beal",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2012/13",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2015/16",
        valueYielded: "הועבר תמורת אל ג'פרסון כשחקן פרנצ'ייז",
        amongBestSleepers: true
      },
      {
        name: "Draymond Green",
        pickedUpVia: "הורם כפרי אייג'נט לקראת סיום עונת הסופמור",
        seasonPicked: "2014/15",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "עונת 2019/20",
        valueYielded: "הועבר תמורת פורזינגיס",
        amongBestSleepers: true
      },
      {
        name: "CJ McCollum",
        pickedUpVia: "הורם כפרי אייג'נט לקראת סיום עונת הסופמור",
        seasonPicked: "2014/15",
        madeFourthYear: true,
        becameFreeKeeper: false,
        valueYielded:
          "הוחלף בקמבה ווקר למשבצת הפרנצ'ייז במחיר של החלפת בחירות עתידית",
          amongBestSleepers: true
      },
      {
        name: "Joel Embiid",
        pickedUpVia: "בחירה אחרונה בסיבוב הראשון לקראת עונת הרוקי-בפועל שלו",
        seasonPicked: "2016/17",
        madeFourthYear: false,
        becameFreeKeeper: true,
        keptUntil: "הועבר בעונתו השלישית כצעיר, 2018/19, במסגרת הבלוקבאסטר המשולש",
        valueYielded: "נארז עם לאורי תמורת יאניס ופול",
        amongBestSleepers: true
      },
      {
        name: "Taurean Prince",
        pickedUpVia: "הורם כפרי אייג'נט בשלהי עונת הרוקי",
        seasonPicked: "2016/17",
        valueYielded: "נשלח עם מלו תמורת וול",
        amongBestSleepers: true
       },
       {
        name: "Kyle Kuzma",
        pickedUpVia: "הגיע כרוקי תמורת מידלטון",
        seasonPicked: "2017/18",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2019/20",
        amongWorstSleepers: true
       },
       {
        name: "Wendell Carter Jr",
        pickedUpVia: "נבחר בסיבוב השלישי כרוקי",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "שוחרר בגין פציעה בשלהי עונתו כשחקן השבחה, 2020/21",
        amongBestSleepers: true
       },
       {
        name: "Marvin Bagley",
        pickedUpVia: "הורם מהווייברס והושבת כרוקי",
        seasonPicked: "2018/19",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "מתישהו בעונתו השלישית, 2020/21",
        amongWorstSleepers: true
       },
       {
        name: "RJ Barrett",
        pickedUpVia: "בחירה שלישית",
        seasonPicked: "2019/20",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2022/23",
        amongWorstSleepers: true
       },
       {
        name: "Anthony Edwards",
        pickedUpVia: "בחירה סוף סיבוב רביעי כרוקי",
        seasonPicked: "2020/21",
        madeFourthYear: true,
        becameFreeKeeper: true,
        amongBestSleepers: true
       },
    ],
  },
  {
    id: nanoid(),
    name: manager.jDog,
    totalSeasons: 4,
    seasonJoined: "2009/10",
    isActive: false,
    rankings: [5, 9, 6, 8],
    movesPerSeason: [143, 42, 98, 12],
    trades: jDogTrades,
    draftPositions: [13, 7, 3, 5],
    bestSnakePicks: [
      {
        pickNumber: 13,
        season: "2009/10",
        draftedPlayer: "David Lee",
        becameKeeper: true,
      },
      {
        pickNumber: 20,
        season: "2011/12",
        draftedPlayer: "Ty Lawson",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 14,
        season: "2009/10",
        draftedPlayer: "Baron Davis",
      },
    ],
    notableSleepers: [
      {
        name: "John Wall",
        pickedUpVia: "הגיע עם עם מרק גאסול תמורת בריאנט ודייויד לי",
        seasonPicked: "2011/12",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil:
          "הועבר לקראת עונת 2016/17 תמורת קאפלה",
        amongBestSleepers: true,
      },
    ],
  },
  {
    id: nanoid(),
    name: manager.alon,
    totalSeasons: 3,
    seasonJoined: "2013/14",
    isActive: false,
    rankings: [10, 8, 10],
    movesPerSeason: [46, 23, 41],
    trades: alonTrades,
    draftPositions: [4, 2, 4],
    bestSnakePicks: [
      {
        pickNumber: 4,
        season: "2013/14",
        draftedPlayer: "Victor Oladipo",
        becameKeeper: true,
      },
      {
        pickNumber: 19,
        season: "2013/14",
        draftedPlayer: "Rudy Gay",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 4,
        season: "2015/16",
        draftedPlayer: "Stanley Johnson",
        becameKeeper: true,
        wasSleeper: true,
      },
    ],
    notableSleepers: [
      {
        name: "Victor Oladipo",
        pickedUpVia: "נבחר רביעי כרוקי",
        seasonPicked: "2013/14",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "שוחרר בעונתו הרביעית לאור איבוד סטטוס שחקן פרנצ'ייז",
        amongBestSleepers: true
      },
      {
        name: "Rudy Gobert",
        pickedUpVia: "נבחר כסופמור בתחילת הסיבוב השלישי",
        seasonPicked: "2014/15",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "הועבר לקראת עונת 2016/17",
        valueYielded: "הועבר לצד קליי ובוקר תמורת קוואי, רנדל ואחרים",
        amongBestSleepers: true
      },
      {
        name: "Andrew Wiggins",
        pickedUpVia: "נבחר שני בדראפט כרוקי",
        seasonPicked: "2014/15",
        valueYielded: "הועבר כרוקי לצד מרקיף מוריס תמורת ווצ'ביץ' ואייזיאה תומאס",
        amongBestSleepers: true
      },
      {
        name: "Stanley Johnson",
        pickedUpVia: "נבחר רביעי כרוקי",
        seasonPicked: "2015/16",
        valueYielded: "הועבר כרוקי תמורת ג'ורדן",
        amongBestSleepers: true
      },
      {
        name: "Devin Booker",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2015/16",
        valueYielded: "הועבר כסופמור לצד גובר וקליי תמורת קוואי, רנדל ואחרים",
        amongBestSleepers: true
      },
    ]
  },
  {
    id: nanoid(),
    name: manager.zeev,
    totalSeasons: 3,
    seasonJoined: "2016/17",
    isActive: false,
    rankings: [8, 1, 2],
    movesPerSeason: [87, 195, 172],
    trades: zeevTrades,
    draftPositions: [4, 3, 4],
    vetDraftPos: [10, 2, 6],
    bestSnakePicks: [
      {
        pickNumber: 19,
        season: "2016/17",
        draftedPlayer: "Jeff Teague",
      },
      {
        pickNumber: 20,
        season: "2017/18",
        draftedPlayer: "Gary Harris",
      },
      {
        pickNumber: 4,
        season: "2018/19",
        draftedPlayer: "Kyrie Irving",
      },
      {
        pickNumber: 12,
        season: "2018/19",
        draftedPlayer: "Nikola Vucevic",
        becameKeeper: true,
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 10,
        season: "2017/18",
        draftedPlayer: "Danilo Gallinari",
      },
    ],
    bestVetPicks: [
      { player: "LaMarcus Aldridge", position: 2, season: "2017/18" },
    ],
    worstVetPicks: [{ player: "Luol Deng", position: 10, season: "2016/17" }],
    notableSleepers: [
      {
        name: "Nikola Jokic",
        pickedUpVia: "הגיע כסופמור לצד אריזה תמורת קוואי ופייבורס",
        seasonPicked: "2016/17",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "קיפר חופשי עד עצם היום הזה",
        amongBestSleepers: true
      },
      {
        name: "Buddy Hield",
        pickedUpVia: "הורם מהווייברס באמצע עונת הרוקי שלו",
        seasonPicked: "2016/17",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2019/20",
        amongBestSleepers: true
      },
      {
        name: "Jamal Murray",
        pickedUpVia: "מהווייברס בתחילת עונת הרוקי שלו",
        seasonPicked: "2016/17",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2018/19, לאחר תרומה נאה לזכיות בזהב ובכסף",
        amongBestSleepers: true
      },
      {
        name: "Mitchell Robinson",
        pickedUpVia: "הרמת פרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2018/19",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2020/21",
        valueYielded: "נשלח עם קליי תמורת קוואי",
        amongBestSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.dror,
    totalSeasons: 3,
    seasonJoined: "2019/20",
    isActive: false,
    rankings: [8, 8, 10],
    movesPerSeason: [20, 34, 29],
    trades: drorTrades,
    draftPositions: [10, 4, 4],
    vetDraftPos: [8, 4, 4],
    worstSnakePicks: [
      {
        pickNumber: 4,
        season: "2020/21",
        draftedPlayer: "Hassan Whiteside",
      },
      {
        pickNumber: 4,
        season: "2021/22",
        draftedPlayer: "Jalen Suggs",
        becameKeeper: true,
        wasSleeper: true,
      },
    ],
    notableSleepers: [
      {
        name: "Tyrese Maxey",
        pickedUpVia: "הורם כפרי אייג'נט בתחילת עונת הסופמור",
        seasonPicked: "2021/22",
        madeFourthYear: true,
        valueYielded: "הועבר בעונת השבחה תמורת סבוניס ג'וניור, סיימונס ומדליית כסף",
        amongBestSleepers: true
       },
       {
        name: "Jalen Suggs",
        pickedUpVia: "נבחר רביעי כרוקי",
        seasonPicked: "2021/22",
        madeFourthYear: false,
        amongWorstSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.yoni,
    totalSeasons: 2,
    seasonJoined: "2022/23",
    isActive: true,
    rankings: [5, 2, 4],
    movesPerSeason: [176, 169, 173],
    trades: yoniTrades,
    draftPositions: [2, 7, 10],
    vetDraftPos: [10, 1, 8],
    bestSnakePicks: [
      {
        pickNumber: 21,
        season: "2022/23",
        draftedPlayer: "Mikal Bridges",
        becameKeeper: true,
      },
      {
        pickNumber: 7,
        season: "2023/24",
        draftedPlayer: "De'Aaron Fox",
        becameKeeper: true,
      },
      {
        pickNumber: 16,
        season: "2023/24",
        draftedPlayer: "Fred VanVleet",
      },
      {
        pickNumber: 10,
        season: "2024/25",
        draftedPlayer: "Jamal Murray",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 2,
        season: "2022/23",
        draftedPlayer: "Zion Williamson",
        becameKeeper: true,
      },
    ],
    notableSleepers: [
      {
        name: "Franz Wagner",
        pickedUpVia: "צורף לקראת עונה שלישית תמורת מיקאל ברידג'ס",
        seasonPicked: "2023/24",
        madeFourthYear: true,
        amongBestSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.michael,
    totalSeasons: 4,
    seasonJoined: "2010/11",
    isActive: false,
    rankings: [11, 8, 4, 11],
    movesPerSeason: [1, 24, 14, 11],
    trades: michaelTrades,
    draftPositions: [11, 12, 3, 8],
    bestSnakePicks: [
      {
        pickNumber: 12,
        draftedPlayer: "Marc Gasol",
        season: "20010/11",
        becameKeeper: true,
      },
      {
        pickNumber: 11,
        draftedPlayer: "Chris Bosh",
        season: "20011/12",
        becameKeeper: true,
      },
      {
        pickNumber: 8,
        season: "2013/14",
        draftedPlayer: "David Lee",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 12,
        season: "2011/12",
        draftedPlayer: "Jason Richardson",
      },
      {
        pickNumber: 3,
        season: "2012/13",
        draftedPlayer: "Pau Gasol",
        becameKeeper: true,
      },
    ],
    notableSleepers: [
      {
        name: "DeMarcus Cousins",
        pickedUpVia: "הגיע כסופמור עם אל ג'פרסון תמורת בוש, מרק גאסול וקונלי",
        seasonPicked: "2011/12",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2017/18",
        amongBestSleepers: true,
      },
      {
        name: "Paul George",
        pickedUpVia: "הורם באמצע עונת הסופמור",
        seasonPicked: "2011/12",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2013/14",
        valueYielded:
          "הועבר לאחר עונה רביעית תמורת קונלי והחלפת בחירות בדראפט וטרנים בגין השבתה לכל העונה",
        amongBestSleepers: true,
      },
      {
        name: "Giannis Antetokounmpo",
        pickedUpVia: "הורם כפרי אייג'נט חודשיים לתוך עונת הרוקי שלו",
        seasonPicked: "2013/14",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "הוחלף בעונתו הראשונה כקיפר חופשי - 2017/18 - בסטף",
        amongBestSleepers: true
      },
    ],
  },
  {
    id: nanoid(),
    name: manager.idan,
    totalSeasons: 12,
    seasonJoined: "2014/15",
    isActive: true,
    rankings: [7, 4, 1, 1, 1, 9, 1, 5, 10, 11, 10],
    movesPerSeason: [100, 200, 200, 200, 200, 81, 148, 199, 26, 75, 100],
    trades: idanTrades,
    draftPositions: [1, 5, 8, 11, 10, 11, 3, 2, 7, 2, 1],
    vetDraftPos: [4, 9, 9, 9, 5, 9, 10, 11],
    bestSnakePicks: [
      {
        pickNumber: 8,
        season: "2016/17",
        draftedPlayer: "Mike Conley",
      },
      {
        pickNumber: 15,
        season: "2016/17",
        draftedPlayer: "Danilo Gallinari",
      },
      {
        pickNumber: 14,
        season: "2017/18",
        draftedPlayer: "Khris Middleton",
        becameKeeper: true,
      },
      {
        pickNumber: 20,
        season: "2020/21",
        draftedPlayer: "OG Anunoby",
      },
      {
        pickNumber: 2,
        season: "2023/24",
        draftedPlayer: "Chet Holmgren",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 1,
        season: "2024/25",
        draftedPlayer: "Donovan Mitchell",
        becameKeeper: true,
      },
      {
        pickNumber: 22,
        season: "2024/25",
        draftedPlayer: "Jakob Poeltl",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 7,
        season: "2022/23",
        draftedPlayer: "Ben Simmons",
      },
      {
        pickNumber: 21,
        season: "2023/24",
        draftedPlayer: "Amen Thompson",
        becameKeeper: true,
        wasSleeper: true,
      },
    ],
    bestVetPicks: [
      { player: "JJ Redick", position: 9, season: "2017/18" },
      { player: "Danilo Gallinari", position: 9, season: "2018/19" },
    ],
    worstVetPicks: [
      { player: "Trevor Ariza", position: 4, season: "2016/17" },
      { player: "LaMarcus Aldridge", position: 5, season: "2020/21" },
      { player: "Klay Thompson", position: 10, season: "2023/24" },
    ],
    notableSleepers: [
      {
        name: "Jabari Parker",
        pickedUpVia: "נבחר ראשון כרוקי",
        seasonPicked: "2014/15",
        valueYielded:
          "הוחלף כרוקי בעסקה מרובת שחקנים שהבולט בה היה ג'ורדן",
          amongBestSleepers: true
      },
      {
        name: "Kristaps Porzingis",
        pickedUpVia: "הורם כפרי אייג'נט ממש בתחילת עונת הרוקי",
        seasonPicked: "2015/16",
        valueYielded:
          "הועבר כסופמור לצד גלינארי תמורת גובר כשחקן פרנצ'ייז וקליי",
          amongBestSleepers: true
      },
      {
        name: "Clint Capela",
        pickedUpVia: "הורם כפרי אייג'נט בשלהי עונת הסופמור",
        seasonPicked: "2015/16",
        valueYielded: "הועבר לקראת עונתו השלישית תמורת ג'ון וול בעסקת טרום-עונה",
        amongBestSleepers: true
      },
      {
        name: "Willy Cauley-Stein",
        pickedUpVia: "הורם כסופמור מיד אחרי הטרייד על קאזינס",
        seasonPicked: "2016/17",
        valueYielded: "הועבר לצד לאורי הפצוע תמורת דראגיץ' ודיינג",
        amongBestSleepers: true
      },
      {
        name: "Jaylen Brown",
        pickedUpVia: "הורם באמצעות ווייבר 1 בפתיחת העונה מיד לאחר שהייוורד גמר עונה בבכורה",
        seasonPicked: "2017/18",
        valueYielded: "הועבר לצד פורטיס תמורת הורפורד והולמס",
        amongBestSleepers: true
       },
       {
        name: "Donovan Mitchell",
        pickedUpVia: "נבחר בתחילת סיבוב רביעי כרוקי, נזרק והוחזר בהרמה בתחילת נובמבר",
        seasonPicked: "2017/18",
        valueYielded: "הועבר תמורת לברון, בעונתו התשיעית ברצף כקיפר חופשי של דטרויט",
        amongBestSleepers: true
       },
       {
        name: "John Collins",
        pickedUpVia: "נבחר כרוקי בסוף הסיבוב השלישי",
        seasonPicked: "2017/18",
        valueYielded: "הועבר לקראת עונת הסופמור תמורת פול ג'ורג'",
        amongBestSleepers: true
       },
       {
        name: "Mikal Bridges",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הסופמור",
        seasonPicked: "2019/20",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2021/22",
        amongBestSleepers: true
       },
       {
        name: "Michael Porter Jr",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי-בפועל שלו",
        seasonPicked: "2019/20",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2021/22",
        valueYielded: "תרם לאליפות 20/21 כסופמור שדורג 19 פר גיים",
        amongBestSleepers: true
       },
       {
        name: "Devonte Graham",
        pickedUpVia: "הורם כפרי אייג'נט בתחילת עונת הסופמור",
        seasonPicked: "2019/20",
        valueYielded: "נארז לקראת עונתו השלישית לצד בחירת סיבוב רביעי תמורת בחירת סיבוב שלישי",
        amongBestSleepers: true
       },
       {
        name: "Tyrese Haliburton",
        pickedUpVia: "הרמת ווייבר באמצע עונת הרוקי",
        seasonPicked: "2020/21",
        valueYielded: "באם, הבטחת הזכייה באליפות והתאפשרות הרילוקיישן למיאמי"
       },
       {
        name: "Keegan Murray",
        pickedUpVia: "צורף כרוקי לצד ג'מארי, MPJ ובחירת סיבוב ראשון תמורת לברון, בחירת סיבוב שלישי וגובר",
        seasonPicked: "2022/23",
        amongBestSleepers: true
       },
       {
        name: "Jalen Williams",
        pickedUpVia: "הורם כפרי אייג'נט בתחילת עונת הרוקי",
        seasonPicked: "2022/23",
        valueYielded: "נשלח כסופמור עם פולטל תמורת סבוניס ג'וניור ואיסון",
        amongBestSleepers: true
       },
       {
        name: "Chet Holmgren",
        pickedUpVia: "נבחר שני כרוקי",
        seasonPicked: "2023/24",
        valueYielded: "הועבר בתחילת עונת הרוקי תמורת לאמלו",
        amongBestSleepers: true
       },
       {
        name: "Brandon Miller",
        pickedUpVia: "הושג כסופמור בטרייד על מיטשל ודיק",
        seasonPicked: "2024/25",
        amongBestSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.ran,
    totalSeasons: 3,
    seasonJoined: "2009/10",
    isActive: false,
    rankings: [5, 7, 11],
    movesPerSeason: [56, 40, 59],
    trades: ranTrades,
    draftPositions: [4, 6, 5],
    bestSnakePicks: [
      {
        pickNumber: 5,
        draftedPlayer: "Joakim Noah",
        season: "2011/12",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 4,
        season: "2009/10",
        draftedPlayer: "Dirk Nowitzki",
        becameKeeper: true,
      },
    ],
    notableSleepers: [
      {
        name: "Russell Westbrook",
        pickedUpVia: " נבחר 49 כסופמור בדראפט הג'נסיס",
        seasonPicked: "2009/10",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2011/12",
        valueYielded: "הוחלף בסטיב נאש ואנדרו בוגוט",
        amongBestSleepers: true,
      },
      {
        name: "Kyrie Irving",
        pickedUpVia: "בחירת אמצע סיבוב שלישי",
        seasonPicked: "2011/12",
        valueYielded: "הועבר כרוקי לפניקס תמורת דורל רייט ואוגוסטין",
        amongBestSleepers: true,
      },
    ],
  },
  {
    id: nanoid(),
    name: manager.oded,
    totalSeasons: 4,
    seasonJoined: "2012/13",
    isActive: false,
    rankings: [11, 9, 9, 11],
    movesPerSeason: [10, 269, 129, 34],
    trades: odedTrades,
    draftPositions: [8, 1, 3, 2],
    bestSnakePicks: [
      {
        pickNumber: 8,
        season: "2012/13",
        draftedPlayer: "Al Horford",
        becameKeeper: true,
      },
      {
        pickNumber: 15,
        season: "2012/13",
        draftedPlayer: "Stephen Curry",
        becameKeeper: true,
      },
      {
        pickNumber: 2,
        season: "2015/16",
        draftedPlayer: "Karl-Anthony Towns",
        becameKeeper: true,
        wasSleeper: true,
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 3,
        season: "2014/15",
        draftedPlayer: "Nicolas Batum",
      },
    ],
    notableSleepers: [
      {
        name: "Kyrie Irving",
        pickedUpVia:
          "צורף כסופמור עם פטריק פטרסון תמורת סטף קארי וכרמלו אנתוני",
        seasonPicked: "2012/13",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2017/18",
        amongBestSleepers: true,
      },
      {
        name: "Ricky Rubio",
        pickedUpVia: "הרמת פרי אייג'נט בתחילת עונת הסופמור",
        seasonPicked: "2012/13",
        valueYielded:
          "הועבר עם דייויד ווסט תמורת ראנדולף ואריק גורדון",
          amongBestSleepers: true
      },
      {
        name: "Nikola Jokic",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2015/16",
        valueYielded: "הועבר כסופמור עם אריזה תמורת קוואי ופייבורס",
        amongBestSleepers: true
      },
      {
        name: "Karl-Anthony Towns",
        pickedUpVia: "בחירה שנייה כרוקי",
        seasonPicked: "2015/16",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "מתחיל עונה שישית (2024/25) כקיפר חופשי ואלוף טרי",
        amongBestSleepers: true
      },
    ],
  },
  {
    id: nanoid(),
    name: manager.shiran,
    totalSeasons: 8,
    seasonJoined: "2016/17",
    isActive: true,
    rankings: [3, 6, 3, 2, 9, 2, 4, 1, 3],
    movesPerSeason: [200, 132, 185, 157, 74, 200, 179, 200, 173],
    trades: shiranTrades,
    draftPositions: [3, 9, 6, 9, 10, 3, 10, 8, 11],
    vetDraftPos: [9, 7, 4, 7, 8, 5, 8, 6, 9],
    bestSnakePicks: [
      {
        pickNumber: 3,
        season: "2016/17",
        draftedPlayer: "DeMar DeRozan",
      },
      {
        pickNumber: 9,
        season: "2019/20",
        draftedPlayer: "Robert Covington",
      },
      {
        pickNumber: 20,
        season: "2021/22",
        draftedPlayer: "Dejounte Murray",
        becameKeeper: true,
      },
      {
        pickNumber: 13,
        season: "2022/23",
        draftedPlayer: "Jalen Brunson",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 12,
        season: "2024/25",
        draftedPlayer: "Deandre Ayton",
      }
    ],
    bestVetPicks: [
      { player: "JJ Redick", position: 9, season: "2016/17" },
      { player: "Mike Conley", position: 4, season: "2018/19" },
      { player: "Jrue Holiday", position: 5, season: "2021/22" },
    ],
    worstVetPicks: [
      { player: "Brook Lopez", position: 8, season: "2020/21" },
      { player: "Bradley Beal", position: 6, season: "2023/24" }, 
      { player: "Jrue Holiday", position: 9, season: "2024/25" },
    ],
    notableSleepers: [
      {
        name: "Rondae Hollis-Jefferson",
        pickedUpVia: "הורם כפרי אייג'נט בשלהי עונת הסופמור",
        seasonPicked: "2016/17",
        valueYielded: "נשלח בעונתו השלישית עם ג'רו הולידיי תמורת פול ג'ורג' ופוקס הרוקי",
        amongBestSleepers: true
      },
      {
        name: "John Collins",
        pickedUpVia: "צורף לקראת עונת הסופמור תמורת פול ג'ורג'",
        seasonPicked: "2018/19",
        keptUntil: "2019/20",
        valueYielded: "הועבר בעונתו השלישית תמורת דרוזן ולונזו",
        amongBestSleepers: true
       },
       {
        name: "Scottie Barnes",
        pickedUpVia: "הורם כפרי אייג'נט בתחילת עונת הרוקי",
        seasonPicked: "2021/22",
        madeFourthYear: true,
        valueYielded: "28 בתרומת פר גיים לאליפות היסטורית בעונתו השלישית",
        amongBestSleepers: true
       },
       {
        name: "Walker Kessler",
        pickedUpVia: "הרמת ווייבר בתחילת עונת הרוקי",
        seasonPicked: "2022/23",
        valueYielded: "דורג 85 פר גיים כסופמור בעונת האליפות",
        amongBestSleepers: true
       },
       {
        name: "Austin Reaves",
        pickedUpVia: "הורם כפרי אייג'נט בשלהי עונת הסופמור",
        seasonPicked: "2022/23",
        valueYielded: "דורג 62 בטוטאל ואליו כסופמור בעונת האליפות",
        amongBestSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.sagi,
    totalSeasons: 3,
    seasonJoined: "2009/10",
    isActive: false,
    rankings: [11, 5, 4],
    movesPerSeason: [53, 6, 229],
    trades: sagiTrades,
    draftPositions: [9, 2, 6],
    bestSnakePicks: [
      {
        pickNumber: 9,
        season: "2009/10",
        draftedPlayer: "Al Jefferson",
        becameKeeper: true,
      },
      {
        pickNumber: 2,
        draftedPlayer: "John Wall",
        season: "20010/11",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 25,
        draftedPlayer: "Demarcus Cousins",
        season: "20010/11",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 17,
        season: "2011/12",
        draftedPlayer: "Tyson Chandler",
        becameKeeper: true,
      },
    ],
    notableSleepers: [
      {
        name: "DeMarcus Cousins",
        pickedUpVia: "בחירה 25 כרוקי",
        seasonPicked: "2010/11",
        valueYielded: "נשלח כסופמור עם אל ג'פרסון תמורת בוש, מרק גאסול וקונלי",
        amongBestSleepers: true,
      },
      {
        name: "John Wall",
        pickedUpVia: "נבחר שני בדראפט כרוקי",
        seasonPicked: "2010/11",
        valueYielded: "נשלח כסופמור עם מרק גאסול תמורת בריאנט ודייויד לי",
        amongBestSleepers: true,
      },
      {
        name: "Klay Thompson",
        pickedUpVia: "הורם כפרי אייג'נט רוקי",
        seasonPicked: "2011/12",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2015/16",
        valueYielded: "זאק ראנדולף",
      },
    ],
  },
  {
    id: nanoid(),
    name: manager.chauncey,
    totalSeasons: 4,
    seasonJoined: "2012/13",
    isActive: false,
    rankings: [1, 2, 1, 1],
    movesPerSeason: [402, 356, 200, 200],
    trades: chaunceyTrades,
    draftPositions: [7, 11, 10, 11],
    bestSnakePicks: [
      {
        pickNumber: 11,
        season: "2013/14",
        draftedPlayer: "Ryan Anderson",
      },
      {
        pickNumber: 11,
        season: "2015/16",
        draftedPlayer: "Greg Monroe",
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 10,
        season: "2014/15",
        draftedPlayer: "Monta Ellis",
      },
    ],
    notableSleepers: [
      {
        name: "Nikola Vucevic",
        pickedUpVia: "הרמת ווייבר בתחילת עונת הסופמור",
        seasonPicked: "2012/13",
        valueYielded: "הועבר כסופמור תמורת קווין מרטין",
        amongBestSleepers: true
      },
      {
        name: "Ricky Rubio",
        pickedUpVia: "צורף כסופמור עם דייויד ווסט תמורת ראנדולף ואריק גורדון",
        seasonPicked: "2012/13",
        madeFourthYear: false,
        becameFreeKeeper: false,
        valueYielded:
          "הועבר בעונתו השלישית תמורת דאנקן",
          amongBestSleepers: true
      },
      {
        name: "Gorgui Dieng",
        pickedUpVia: "הגיע כסופמור לצד צ'אנדלר תמורת ג'ורדן",
        seasonPicked: "2013/14",
        madeFourthYear: false,
        becameFreeKeeper: false,
        valueYielded:
          "הועבר בהמשך עונת הסופמור תמורת דרוזן",
          amongBestSleepers: true
      },
    ]
  },
  {
    id: nanoid(),
    name: manager.ilya,
    totalSeasons: 5,
    seasonJoined: "2016/17",
    isActive: false,
    rankings: [8, 10, 6, 11, 10],
    movesPerSeason: [131, 86, 152, 75, 85],
    trades: ilyaTrades,
    draftPositions: [10, 4, 7, 6, 1],
    vetDraftPos: [11, 1, 10, 2, 11],
    bestSnakePicks: [
      {
        pickNumber: 13,
        season: "2016/17",
        draftedPlayer: "Marc Gasol",
      },
      {
        pickNumber: 21,
        season: "2018/19",
        draftedPlayer: "Robert Covington",
      },
      {
        pickNumber: 6,
        season: "2019/20",
        draftedPlayer: "Bradley Beal",
        becameKeeper: true,
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 4,
        season: "2017/18",
        draftedPlayer: "Dennis Smith Jr",
        becameKeeper: true,
        wasSleeper: true,
      },
      {
        pickNumber: 1,
        season: "2020/21",
        draftedPlayer: "Jusuf Nurkic",
      },
      {
        pickNumber: 14,
        season: "2020/21",
        draftedPlayer: "Eric Bledsoe",
      },
    ],
    bestVetPicks: [{ player: "Al Horford", position: 10, season: "2018/19" }],
    worstVetPicks: [
      { player: "Deron Williams", position: 11, season: "2016/17" },
      { player: "Mike Conley", position: 1, season: "2017/18" },
      { player: "Mike Conley", position: 2, season: "2019/20" },
    ],
    notableSleepers: [
      {
        name: "Jahlil Okafor",
        pickedUpVia: "צורף כסופמור לצד ביל תמורת מרק גאסול",
        seasonPicked: "2016/17",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "שוחרר במהלך עונת 2017/18",
        amongWorstSleepers: true
      },
      {
        name: "Brandon Ingram",
        pickedUpVia: "הורם מהווייברס בתחילת עונת הרוקי שלו",
        seasonPicked: "2016/17",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2018/19, עונה לפני הפריצה",
        amongWorstSleepers: true
      },
      {
        name: "Dennis Smith Jr",
        pickedUpVia: "נבחר רביעי כרוקי",
        seasonPicked: "2017/18",
        madeFourthYear: false,
        becameFreeKeeper: false,
        keptUntil: "2019/20",
        amongWorstSleepers: true
       },
       {
        name: "Collin Sexton",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2018/19",
        madeFourthYear: true,
        becameFreeKeeper: false,
        keptUntil: "2021/22",
        amongBestSleepers: true
       },
       {
        name: "Darius Garland",
        pickedUpVia: "הורם כפרי אייג'נט באמצע עונת הרוקי",
        seasonPicked: "2019/20",
        madeFourthYear: true,
        becameFreeKeeper: true,
        keptUntil: "2023/24",
        amongBestSleepers: true
       },
       {
        name: "James Wiseman",
        pickedUpVia: "בחירה 22 כרוקי",
        seasonPicked: "2020/21",
        keptUntil: "2021/22",
        amongWorstSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.rony,
    totalSeasons: 3,
    seasonJoined: "2021/22",
    isActive: false,
    rankings: [9, 6, 9],
    movesPerSeason: [132, 134, 98],
    trades: ronyTrades,
    draftPositions: [11, 3, 6],
    vetDraftPos: [10, 5, 2],
    bestSnakePicks: [
      {
        pickNumber: 11,
        season: "2021/22",
        draftedPlayer: "Jonas Valanciunas",
      },
      {
        pickNumber: 21,
        season: "2021/22",
        draftedPlayer: "Alperen Sengun",
        becameKeeper: true,
        wasSleeper: true,
      },
    ],
    worstSnakePicks: [
      {
        pickNumber: 20,
        season: "2022/23",
        draftedPlayer: "Jordan Poole",
      },
    ],
    bestVetPicks: [{ player: "DeMar DeRozan", position: 5, season: "2022/23" }],
    notableSleepers: [
      {
        name: "Alperen Sengun",
        pickedUpVia: "נבחר בשלהי סיבוב שני כרוקי",
        seasonPicked: "2021/22",
        madeFourthYear: true,
        valueYielded: "הועבר כרוקי תמורת רנדל וטייט",
        amongBestSleepers: true
       },
       {
        name: "Jabari Smith",
        pickedUpVia: "נבחר שלישי כרוקי",
        seasonPicked: "2022/23",
        valueYielded: "הועבר כרוקי תמורת פורזינגיס, הוחזר כסופמור תמורת הנדרסון; הועבר לקראת עונה שלישית תמורת מרקנן ומתורין",
        amongBestSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.shahar,
    totalSeasons: 1,
    seasonJoined: "2024/25",
    isActive: false,
    rankings: [11],
    movesPerSeason: [10],
    trades: shaharTrades,
    draftPositions: [6],
    vetDraftPos: [10],
    bestSnakePicks: [],
    worstSnakePicks: [],
    notableSleepers: [
      {
        name: "Kel'el Ware",
        pickedUpVia: "הרמת ווייבר כרוקי",
        seasonPicked: "2024/25",
        amongBestSleepers: true
       },
    ]
  },
  {
    id: nanoid(),
    name: manager.ben,
    totalSeasons: 1,
    seasonJoined: "2025/26",
    isActive: true,
    rankings: [],
    movesPerSeason: [],
    trades: benTrades,
    draftPositions: [1],
    vetDraftPos: [11],
    bestSnakePicks: [],
    worstSnakePicks: [],
    notableSleepers: []
  },
  {
    id: nanoid(),
    name: manager.darko,
    totalSeasons: 1,
    seasonJoined: "2009/10",
    isActive: false,
    rankings: [13],
    movesPerSeason: [23],
    draftPositions: [12],
  },
  {
    id: nanoid(),
    name: manager.inbal,
    totalSeasons: 1,
    seasonJoined: "2010/11",
    isActive: false,
    rankings: [10],
    movesPerSeason: [15],
    draftPositions: [13],
  },
  {
    id: nanoid(),
    name: manager.spurs,
    totalSeasons: 1,
    seasonJoined: "2009/2010",
    isActive: false,
    rankings: [10],
    movesPerSeason: [1],
    draftPositions: [7],
  },
  {
    id: nanoid(),
    name: manager.asa,
    totalSeasons: 2,
    seasonJoined: "2009/10",
    isActive: false,
    rankings: [7, 6],
    movesPerSeason: [32, 35],
    trades: asaTrades,
    draftPositions: [10, 5],
  },
];
